import React, { useEffect, useState } from 'react';
import AppBreadCrumb from '../../common/AppBreadCrumb'; // Correct path
import { createRateType, fetchRateType, updateRateType } from '../../../api/RateTypesAPI'; // Correct path
import { handleApiError } from '../../../api/risapi'; // Correct path
import AppToaster from '../../AppToaster'; // Correct path
import { useNavigate, useParams } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../../commonfunctions'; // Correct path

const RateTypesForm = ({ formType, currentRateTypeId }) => {
    const navigate = useNavigate();
    const [currentRateType, setCurrentRateType] = useState({ name: '' });
    const [currentRateTypeError, setCurrentRateTypeError] = useState({});
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setCurrentRateType({ name: '' });
        setCurrentRateTypeError({});
        if (formType === 'edit' && currentRateTypeId) {
            setLoading(true);
            fetchRateType(currentRateTypeId, function (response) {
                setLoading(false);
                if (response.rate_type) {
                    setCurrentRateType(response.rate_type);
                } else {
                    handleApiError(response, () => { });
                    setToaster({ type: 'danger', heading: 'Error', message: 'Could not load Rate Type.' });
                    setShowToaster(true);
                    navigate('/franchisee_user/masters/rate-types');
                }
            });
        }
    }, [formType, currentRateTypeId, navigate]);

    const saveForm = (exitForm) => {
        setCurrentRateTypeError({});
        setLoading(true);
        const apiCall = formType === 'create' ? createRateType : updateRateType;
        const dataToSend = { ...currentRateType }; // Send id for update

        apiCall(dataToSend, function (response) {
            setLoading(false);
            if (response.rate_type) {
                if (exitForm) {
                    navigate('/franchisee_user/masters/rate-types', { state: { message: `Rate Type ${formType === 'create' ? 'saved' : 'updated'} successfully!` } });
                } else if (formType === 'create') {
                    setCurrentRateType({ name: '' }); // Reset
                    setToaster({ type: 'success', heading: 'Success', message: 'Rate Type Added Successfully' });
                    setShowToaster(true);
                } else { // Edit mode, saved without exiting
                    setToaster({ type: 'success', heading: 'Success', message: 'Rate Type Updated Successfully' });
                    setShowToaster(true);
                    // Data already updated in state via onChange
                }
            } else {
                handleApiError(response, setCurrentRateTypeError);
                setToaster({ type: 'danger', heading: 'Error', message: `Could not ${formType} Rate Type.` });
                setShowToaster(true);
            }
        });
    };

    const handleReset = () => {
        if (formType === 'create') {
            setCurrentRateType({ name: '' });
            setCurrentRateTypeError({});
        } else if (currentRateTypeId) {
            setLoading(true);
            fetchRateType(currentRateTypeId, function (response) {
                setLoading(false);
                if (response.rate_type) {
                    setCurrentRateType(response.rate_type);
                    setCurrentRateTypeError({}); // Clear errors
                } else {
                    setToaster({ type: 'danger', heading: 'Error', message: 'Could not reload data.' });
                    setShowToaster(true);
                }
            });
        }
    };


    const getTitle = () => formType === 'create' ? 'Create New Rate Type' : 'Edit Rate Type';

    return (
        <>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <main>
                <div className="container-fluid">
                    <AppBreadCrumb title={getTitle()}>
                        <li><a className="f-s-14 f-w-500" href="#">Masters</a></li>
                        <li><a className="f-s-14 f-w-500" href="/franchisee_user/masters/rate-types">Rate Types</a></li>
                        <li className="active"><a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a></li>
                    </AppBreadCrumb>

                    {loading && <div className="loader_box"><div className="loader_14"></div></div>}

                    {!loading && (
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>{formType === 'create' ? 'Add New' : 'Edit'} Rate Type {formType === 'edit' ? `: ${currentRateType?.name || ''}` : ''}</h5>
                                    </div>
                                    <div className="card-body">
                                        <form className="app-form" onSubmit={(e) => e.preventDefault()}>
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label"> Name *</label>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Enter Rate Type Name (e.g., MRP, Wholesale)"
                                                        value={currentRateType?.name || ''}
                                                        onChange={(e) => setCurrentRateType({ ...currentRateType, name: e.target.value })}
                                                        required
                                                        type="text"
                                                    />
                                                    <div className="mt-1">
                                                        <span className="text-danger">{currentRateTypeError?.name}</span>
                                                    </div>
                                                </div>

                                                <div className="col-12 mt-3">
                                                    <div className="text-end">
                                                        {formType === 'create' ? (
                                                            <>
                                                                <button className="btn btn-outline-primary me-2 btn-sm" type="button" onClick={() => saveForm(false)} disabled={loading}>Save + Next</button>
                                                                <button className="btn btn-primary me-2 btn-sm" type="button" onClick={() => saveForm(true)} disabled={loading}>Save + Exit</button>
                                                                <button className="d-none d-md-inline-block btn btn-danger btn-sm me-2" onClick={handleReset} type="button" disabled={loading}>Reset</button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <button className="btn btn-primary me-2 btn-sm" type="button" onClick={() => saveForm(true)} disabled={loading}>Update</button>
                                                                
                                                            </>
                                                        )}

                                                        <button className="d-none  d-md-inline-block btn btn-light-reddit b-r-22 d-inline-flex-center" type="button" onClick={() => navigate('/franchisee_user/masters/rate-types')} >Go Back</button>

                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>
        </>
    );
};

export default RateTypesForm;